import { render, staticRenderFns } from "./TabletList.vue?vue&type=template&id=6ed29174&scoped=true&lang=pug"
import script from "./TabletList.vue?vue&type=script&lang=ts"
export * from "./TabletList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed29174",
  null
  
)

export default component.exports